import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
  useTheme,
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { DirectionsBoat as KayakIcon } from '@mui/icons-material';

const Navbar = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isAuthenticated = localStorage.getItem('token');

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <AppBar position="sticky" sx={{ backgroundColor: 'white' }}>
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Box
            component={RouterLink}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              color: 'primary.main',
            }}
          >
            <KayakIcon sx={{ fontSize: 32, mr: 1 }} />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: 'primary.main',
              }}
            >
              Delaware Kayak Guide
            </Typography>
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              component={RouterLink}
              to="/locations"
              color="primary"
              sx={{ fontWeight: 500 }}
            >
              Locations
            </Button>
            {isAuthenticated ? (
              <>
                <Button
                  component={RouterLink}
                  to="/admin"
                  color="primary"
                  sx={{ fontWeight: 500 }}
                >
                  Admin
                </Button>
                <Button
                  onClick={handleLogout}
                  color="primary"
                  variant="outlined"
                  sx={{ fontWeight: 500 }}
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button
                  component={RouterLink}
                  to="/login"
                  color="primary"
                  sx={{ fontWeight: 500 }}
                >
                  Login
                </Button>
                <Button
                  component={RouterLink}
                  to="/register"
                  color="primary"
                  variant="contained"
                  sx={{ fontWeight: 500 }}
                >
                  Register
                </Button>
              </>
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navbar; 